
<div class="container">
  <div class="row mt-3">
    <div class="col-md-2">&nbsp;</div>
    <div class="col-md-8">
      <h5>Service Account:</h5>
      <error [error]="error"></error>
      <form #projectForm="ngForm" (ngSubmit)="save()" autocomplete="off">
        <div class="card-block">
          <div class="form-group">
            <label class="required" for="uid">Service Key</label>
            <div class="input-group">
              <input class="form-control" id="uid" [(ngModel)]="user.uid" type="email" name="uid" required="true" pattern="[a-zA-Z0-9_.]+@(.*\.){0,1}(hp\.com|HP\.COM)" maxlength="60">
            </div>
          </div>
          <div class="form-group">
            <label class="required" for="emailAddress">Email Address</label>
            <input class="form-control" id="emailAddress" [(ngModel)]="user.emailAddress" type="email" name="emailAddress" [required]="true" pattern="[a-zA-Z0-9_.]+@(.*\.){0,1}(hp\.com|HP\.COM)" maxlength="60">
          </div>
          <div class="form-group">
            <label>Roles</label>
            <select class="form-control" [(ngModel)]="rolesSelected" name="rolesSelected" multiple>
              <option *ngFor="let role of roles" [ngValue]="role.id">{{ role.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label class="required">Incoming Authentication Mechanism</label>
            <select class="form-control" [(ngModel)]="user.incomingAuthenticationMechanism" name="incomingAuthenticationMechanism">
              <option value=""></option>
              <option value="aws4">AWS4 Signed Request</option>
              <option value="plain">API Key & Secret Headers</option>
            </select>
          </div>
          <div class="form-group">
            <label class="required">Outgoing Authentication Mechanism</label>
            <select class="form-control" [(ngModel)]="user.outgoingAuthenticationMechanism" name="outgoingAuthenticationMechanism">
              <option value=""></option>
              <option value="aws4">AWS4 Signed Request</option>
            </select>
          </div>
          <div class="form-group">
            <label for="installationPartnerDeploymentChanged">Installation Partner - Deployment Changed</label>
            <input class="form-control" id="installationPartnerDeploymentChanged" [(ngModel)]="user.webhooks['installation-partner-deployment-changed']" type="text" name="installationPartnerDeploymentChanged" [required]="false" maxlength="120">
          </div>
          <div class="form-group">
            <label for="partnerName">Organization</label>
            <input class="form-control" id="partnerName" [(ngModel)]="user.organization" name="partnerName" maxlength="60" autocomplete="off">
          </div>
          <div class="form-group">
            <div class="btn-group float-right"><a class="btn btn-outline-secondary ml-1" [href]="'/#/service-accounts'">Cancel</a>
              <button class="btn btn-primary" type="submit">Save</button>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>